import requests from './requests';

export default {
    get() {
        return requests
            .get('/trainer/trainer')
            .then(resp => resp.data);
    },
    patch(payload) {
        return requests
            .patch('/trainer/trainer', payload)
            .then(resp => resp.data);
    },
    wechat_unbind() {
        return requests
            .put('/trainer/trainer/wechat_unbind')
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/trainer.js